var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.74 18.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.74,6.87c-.06.37-.11.75-.18,1.11-.31,1.44-.93,2.74-1.77,3.94-1.79,2.59-4.02,4.72-6.75,6.3-.46.27-.96.45-1.46.64-.12.05-.3.04-.43,0-.88-.26-1.66-.71-2.41-1.22-2.56-1.75-4.71-3.88-6.32-6.55C.72,9.92.24,8.64.06,7.26.04,7.13.02,7,0,6.87c0-.35,0-.7,0-1.05.07-.38.11-.76.21-1.13.11-.39.26-.77.41-1.14.09-.23.33-.31.54-.22.21.09.3.32.2.55-.86,1.88-.63,3.74.15,5.57.73,1.72,1.85,3.16,3.12,4.5,1.36,1.42,2.85,2.69,4.58,3.64.28.16.59.27.88.42.21.11.4.08.62,0,1.02-.42,1.93-1.02,2.8-1.69,1.92-1.47,3.58-3.18,4.89-5.22.71-1.11,1.22-2.31,1.46-3.61.42-2.33-.55-4.66-2.47-5.85-2.11-1.31-4.73-1.04-6.54.68-.04.04-.08.08-.12.11-.25.23-.44.23-.69,0-.6-.58-1.27-1.02-2.06-1.29-1.42-.49-2.8-.4-4.14.26-.04.02-.08.04-.13.06-.24.11-.47.05-.58-.16-.11-.21-.03-.44.21-.56C3.97.38,4.64.15,5.36.06c1.83-.24,3.44.26,4.86,1.43.05.04.09.08.15.12.18-.14.36-.29.54-.42,3.61-2.62,8.71-.68,9.67,3.67.07.31.11.63.16.95v1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.43,2.19c0,.22-.18.4-.4.4-.23,0-.42-.19-.41-.41,0-.22.19-.39.41-.39.22,0,.4.18.4.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackHeart);
export default __webpack_public_path__ + "static/media/blackHeart.ec288bd4b32cf88550b8c9817e025d7c.svg";
export { ForwardRef as ReactComponent };